var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-btn',{attrs:{"text":"","small":"","color":"primary","href":"https://app.docpool.io/signup","target":"_blank"}},[_vm._v("\n    Get your own page at Docpool\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }